import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const MicrosoftTeams = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <clipPath id="microsoftteams_clip_path">
        <rect
          id="microsoftteams_layer"
          fill="none"
          y="0.2"
          width="24"
          height="23.6"
        />
      </clipPath>
      <linearGradient
        id="microsoftteams_____________________2"
        x1="2.01"
        y1="21.21"
        x2="10.27"
        y2="6.79"
        gradientTransform="matrix(1, 0, 0, -1, 0, 26)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="hsl(from hsl(239 28% 52%) h s 46%)" />
        <stop offset="0.5" stopColor="hsl(from hsl(239 28% 52%) h s 42%)" />
        <stop offset="1" stopColor="hsl(from hsl(239 28% 52%) h s 34%)" />
      </linearGradient>
    </defs>
    <g id="microsoftteams_layer_2" data-name="layer">
      <g clipPath="url(#microsoftteams_clip_path)">
        <g id="microsoftteams_layer_3" data-name="layer">
          <path
            id="microsoftteams_layer_4"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 44%)"
            d="M16.74,9.05h6.2A1.09,1.09,0,0,1,24,10.17v6a4,4,0,0,1-3.9,4.12h0a4,4,0,0,1-3.89-4.12h0V9.64A.56.56,0,0,1,16.74,9.05Z"
          />
          <path
            id="microsoftteams_layer_5"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 44%)"
            d="M20.93,7.87a2.58,2.58,0,0,0,2.51-2.65,2.51,2.51,0,1,0-5,0A2.58,2.58,0,0,0,20.93,7.87Z"
          />
          <path
            id="microsoftteams_layer_6"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 60%)"
            d="M13.12,7.87A3.73,3.73,0,0,0,16.74,4,3.73,3.73,0,0,0,13.12.2,3.74,3.74,0,0,0,9.49,4,3.73,3.73,0,0,0,13.12,7.87Z"
          />
          <path
            id="microsoftteams_layer_7"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 60%)"
            d="M18,9.05H7.72a1.08,1.08,0,0,0-1,1.13V17a6.5,6.5,0,0,0,6.14,6.81A6.51,6.51,0,0,0,19,17V10.18A1.09,1.09,0,0,0,18,9.05Z"
          />
          <path
            id="microsoftteams_layer_8"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 36%)"
            opacity="0.1"
            d="M13.4,9.05v9.54a1.11,1.11,0,0,1-.64,1,1,1,0,0,1-.39.08H7.19c-.07-.19-.14-.39-.2-.59A7.75,7.75,0,0,1,6.7,17V10.18a1.08,1.08,0,0,1,1-1.13Z"
          />
          <path
            id="microsoftteams_layer_9"
            data-name="layer"
            opacity="0.2"
            d="M12.84,9.05V19.18a1.15,1.15,0,0,1-.08.41,1,1,0,0,1-.94.67H7.45c-.09-.19-.18-.39-.26-.59s-.14-.39-.2-.59A7.75,7.75,0,0,1,6.7,17V10.18a1.08,1.08,0,0,1,1-1.13Z"
          />
          <path
            id="microsoftteams_layer_10"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 36%)"
            opacity="0.2"
            d="M12.84,9.05v9a1.06,1.06,0,0,1-1,1.08H7A7.75,7.75,0,0,1,6.7,17V10.18a1.08,1.08,0,0,1,1-1.13Z"
          />
          <path
            id="microsoftteams_layer_11"
            data-name="layer"
            opacity="0.2"
            d="M12.28,9.05v9a1.06,1.06,0,0,1-1,1.08H7A7.75,7.75,0,0,1,6.7,17V10.18a1.08,1.08,0,0,1,1-1.13Z"
          />
          <path
            id="microsoftteams_layer_12"
            data-name="layer"
            opacity="0.1"
            d="M13.4,6V7.86h-.56a2.63,2.63,0,0,1-.56-.1A3.69,3.69,0,0,1,9.77,5.51a3.09,3.09,0,0,1-.18-.59h2.78A1.06,1.06,0,0,1,13.4,6Z"
          />
          <path
            id="microsoftteams_layer_13"
            data-name="layer"
            opacity="0.2"
            d="M12.84,6.59V7.86a2.63,2.63,0,0,1-.56-.1A3.69,3.69,0,0,1,9.77,5.51h2.05A1.05,1.05,0,0,1,12.84,6.59Z"
          />
          <path
            id="microsoftteams_layer_14"
            data-name="layer"
            opacity="0.2"
            d="M12.84,6.59V7.86a2.63,2.63,0,0,1-.56-.1A3.69,3.69,0,0,1,9.77,5.51h2.05A1.05,1.05,0,0,1,12.84,6.59Z"
          />
          <path
            id="microsoftteams_layer_15"
            data-name="layer"
            opacity="0.2"
            d="M12.28,6.59V7.76A3.69,3.69,0,0,1,9.77,5.51h1.49A1.05,1.05,0,0,1,12.28,6.59Z"
          />
          <path
            id="microsoftteams_layer_16"
            data-name="layer"
            fill="url(#microsoftteams_____________________2)"
            d="M1,5.51H11.26a1.05,1.05,0,0,1,1,1.08V17.41a1.05,1.05,0,0,1-1,1.08H1a1.05,1.05,0,0,1-1-1.08V6.59A1.05,1.05,0,0,1,1,5.51Z"
          />
          <path
            id="microsoftteams_layer_17"
            data-name="layer"
            fill="hsl(from hsl(239 28% 52%) h s 100%)"
            d="M8.83,9.63h-2v5.89H5.48V9.63h-2V8.48H8.83Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
